import {useOnlineStatus} from "../hooks/useOnlineStatus";

export function VersionTag({version, connectivity, onClick}) {
  const handleClick = () => {
    if (onClick) onClick();
  };

  const getAppEnvironmentKey = () => {
    const hostname = window.location.hostname;
    if (hostname === '127.0.0.1' || hostname === 'localhost') {
      return 'LOC';
    } else if (hostname === 'self-ordering-kiosk-357d7--development-6uyedfez.web.app') {
      return 'DEV';
    } else if (hostname === 'self-ordering-kiosk-357d7--staging-rj2g30lj.web.app') {
      return 'STA';
    } else if (hostname === 'self-ordering-kiosk-357d7.web.app' || hostname === 'sok.motiondisplays.com') {
      return 'PRO';
    } else {
      return 'UNK';
    }
  };

  const getDBEnvironmentKey = () => {
    const environment = import.meta.env.REACT_APP_ENV || 'development';
    switch (environment) {
      case 'development':
        return 'DEV';
      case 'staging':
        return 'STA';
      case 'production':
        return 'PRO';
      default:
        return 'UNK';
    }
  };

  const online = useOnlineStatus();
  const appEnv = getAppEnvironmentKey();
  const dbEnv = getDBEnvironmentKey();
  // SOK-04: con el latido de useConnectivity se distingue la red lenta (🟡) de la caída.
  const status = connectivity || (online ? 'online' : 'offline');
  const onlineTag = status === 'online' ? " 🟢" : status === 'degraded' ? " 🟡" : " 🔴";
  const versionTagString = `[V:${version}]${appEnv === dbEnv ? `[${appEnv}]` : `[APP:${appEnv}][DB:${dbEnv}]`}${onlineTag}`

  return (
    <div className='version-tag' onClick={handleClick}>{versionTagString}</div>
  );
}